var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { style: _vm.style })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@15.7.0@vue-loader/lib/loaders/templateLoader.js?{"failOnHint":true}!./node_modules/_vue-loader@15.7.0@vue-loader/lib?{"failOnHint":true}!./node_modules/_vue-monaco-editor@0.0.19@vue-monaco-editor/src/Monaco.vue?vue&type=template&id=41d0567f&
// module id = ./node_modules/_vue-loader@15.7.0@vue-loader/lib/loaders/templateLoader.js?{"failOnHint":true}!./node_modules/_vue-loader@15.7.0@vue-loader/lib/index.js?{"failOnHint":true}!./node_modules/_vue-monaco-editor@0.0.19@vue-monaco-editor/src/Monaco.vue?vue&type=template&id=41d0567f&
// module chunks = 1